import React, { useEffect } from "react";
import {
  AuthHeader,
  AuthWrapper,
  ModalHeader,
  ModalTag,
  SubmitButton,
  SecondaryButton,
} from "./styles";
import { useHistory } from "react-router-dom";

import { modalData } from "./helper";

function ModalBlock({ handleClose, type = "warning", handleDelete }) {
  const history = useHistory();
  useEffect(() => {
    if (type === "success") {
      setTimeout(() => {
        history.push("/");
        sessionStorage.clear();
      }, 5000);
    }
  }, [type]);
  const renderLogo = (type) => {
    switch (type) {
      case "warning":
        return <WarningLogo />;
      case "success":
        return <SuccessLogo />;
      case "not_allowed":
        return <NotAllowedLogo />;
      case "auth":
        return <AuthLogo />;
      case "verify":
        return <VerifyLogo />;
    }
  };
  return (
    <AuthWrapper>
      <AuthHeader>
        <div style={{ paddingBottom: "16px" }}>{renderLogo(type)}</div>
        {modalData[type].header && (
          <ModalHeader>{modalData[type].header}</ModalHeader>
        )}
        <ModalTag>{modalData[type].content}</ModalTag>
      </AuthHeader>
      <div
        style={{
          textAlign: "right",
          marginTop: type === "success" ? "32px" : "40px",
        }}
      >
        {type === "warning" && (
          <SecondaryButton onClick={handleDelete}>Yes</SecondaryButton>
        )}
        <SubmitButton $isValid={true} $width="100px" onClick={handleClose}>
          {modalData[type].button}
        </SubmitButton>
      </div>
    </AuthWrapper>
  );
}

export default ModalBlock;

export const WarningLogo = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36z"
        fill="#D71A63"
      />
      <path
        d="M53.563 47.563c1.124 2-.313 4.437-2.626 4.437H21c-2.313 0-3.75-2.5-2.625-4.438l15-26.062c1.125-2 4.063-1.938 5.188 0l15 26.063zM36 42.124A2.867 2.867 0 0 0 33.125 45c0 1.625 1.25 2.875 2.875 2.875A2.867 2.867 0 0 0 38.875 45c0-1.563-1.313-2.875-2.875-2.875zm-2.75-10.313.438 8.5c.062.438.374.688.75.688H37.5c.375 0 .688-.25.75-.688l.438-8.5c.062-.437-.313-.812-.75-.812H34c-.438 0-.813.375-.75.813z"
        fill="#fff"
      />
    </svg>
  );
};
export const AuthLogo = () => {
  return (
    <svg
      width="144"
      height="96"
      viewBox="0 0 144 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#6n2uf8irga)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.987 50.889V37.444c0-4.522 2.406-8.703 6.313-10.979l12.704-7.394a12.707 12.707 0 0 1 12.78 0l12.705 7.394a12.704 12.704 0 0 1 6.316 10.98v13.444c0 4.522-2.406 8.703-6.313 10.979l-12.704 7.394a12.708 12.708 0 0 1-12.78 0l-12.705-7.394a12.703 12.703 0 0 1-6.316-10.98z"
          fill="#D71A63"
        />
        <path
          d="M75.396 44.167V31.462m-.003 22.586a.702.702 0 0 0-.703.706.706.706 0 0 0 1.412 0 .706.706 0 0 0-.709-.706z"
          stroke="#fff"
          stroke-width="6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.937 66.216h.828a.362.362 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.362.362 0 0 1-.361-.361v-.828a.36.36 0 0 1 .361-.362zm2.872 0h.828a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.828a.363.363 0 0 1-.362-.361v-.828a.362.362 0 0 1 .361-.362zm2.873 0h.828a.363.363 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.362.362 0 0 1-.361-.361v-.828a.36.36 0 0 1 .36-.362zm2.871 0h.829a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.829a.363.363 0 0 1-.363-.361v-.828a.366.366 0 0 1 .363-.362zm2.872 0h.828a.363.363 0 0 1 .364.362v.828a.362.362 0 0 1-.364.361h-.828a.362.362 0 0 1-.361-.361v-.828a.363.363 0 0 1 .361-.362zm-8.511 3.131h.828a.363.363 0 0 1 .361.362v.83a.363.363 0 0 1-.36.361h-.83a.362.362 0 0 1-.36-.361v-.829a.362.362 0 0 1 .36-.363zm2.871 0h.829a.363.363 0 0 1 .361.362v.83a.364.364 0 0 1-.361.361h-.829a.363.363 0 0 1-.361-.361v-.829a.362.362 0 0 1 .361-.363zm2.872 0h.828a.363.363 0 0 1 .363.362v.83a.363.363 0 0 1-.363.361h-.828a.363.363 0 0 1-.361-.361v-.829a.363.363 0 0 1 .361-.363zm-2.975-6.495h.828a.363.363 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .36-.36zm2.871 0h.829a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.829a.363.363 0 0 1-.363-.36v-.83a.365.365 0 0 1 .363-.36zm62.172-43.498h.828a.363.363 0 0 1 .362.361v.828a.36.36 0 0 1-.362.362h-.828a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.828a.365.365 0 0 1-.362-.362v-.828a.365.365 0 0 1 .362-.361zm2.873 0h.828a.365.365 0 0 1 .362.361v.828a.36.36 0 0 1-.362.362h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.871 0h.829a.364.364 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.362.362 0 0 1-.363-.362v-.828a.365.365 0 0 1 .363-.361zm2.872 0h.828a.365.365 0 0 1 .364.361v.828a.366.366 0 0 1-.225.335.362.362 0 0 1-.139.027h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm-8.511 3.13h.828a.365.365 0 0 1 .362.361v.831a.365.365 0 0 1-.362.362h-.828a.366.366 0 0 1-.362-.362v-.828a.368.368 0 0 1 .106-.257.354.354 0 0 1 .256-.106zm2.871 0h.829a.364.364 0 0 1 .361.362v.83a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.367.367 0 0 1 .105-.257.369.369 0 0 1 .256-.106zm2.872 0h.828a.366.366 0 0 1 .364.361v.831a.366.366 0 0 1-.364.362h-.828a.362.362 0 0 1-.361-.362v-.828a.364.364 0 0 1 .361-.363zm-2.975-6.494h.828a.365.365 0 0 1 .362.361v.829a.36.36 0 0 1-.362.36h-.828a.362.362 0 0 1-.361-.36v-.829a.36.36 0 0 1 .361-.361zm2.871 0h.829a.364.364 0 0 1 .361.361v.829a.36.36 0 0 1-.361.36h-.829a.363.363 0 0 1-.363-.36v-.829a.366.366 0 0 1 .363-.361zm-76.636 4.155h.829a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.829a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .361-.36zm2.872 0h.828a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.828a.363.363 0 0 1-.362-.36v-.83a.363.363 0 0 1 .362-.36zm2.873 0h.828a.362.362 0 0 1 .362.36v.83a.362.362 0 0 1-.362.36h-.828a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .361-.36zm2.872 0h.828a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.828a.363.363 0 0 1-.364-.36v-.83a.365.365 0 0 1 .364-.36zm2.871 0h.829a.363.363 0 0 1 .363.36v.83a.363.363 0 0 1-.363.36h-.829a.363.363 0 0 1-.361-.36v-.83a.363.363 0 0 1 .361-.36zm-8.51 3.13h.827a.363.363 0 0 1 .362.362v.83a.363.363 0 0 1-.362.362h-.828a.362.362 0 0 1-.361-.362v-.828a.359.359 0 0 1 .361-.363zm2.87 0h.829a.363.363 0 0 1 .361.362v.83a.363.363 0 0 1-.361.362h-.828a.362.362 0 0 1-.362-.362v-.828a.362.362 0 0 1 .362-.363zm2.872 0h.829a.363.363 0 0 1 .363.362v.83a.364.364 0 0 1-.363.362h-.829a.363.363 0 0 1-.361-.362v-.828a.363.363 0 0 1 .361-.363zm-2.975-6.494h.828a.363.363 0 0 1 .362.361v.828a.362.362 0 0 1-.362.362h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.363.363 0 0 1 .361.361v.828a.361.361 0 0 1-.361.362h-.828a.363.363 0 0 1-.364-.362v-.828a.366.366 0 0 1 .364-.361zm60.319 49.623h.829a.359.359 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.365.365 0 0 1 .362.361v.828a.365.365 0 0 1-.362.362h-.828a.365.365 0 0 1-.362-.362v-.828a.365.365 0 0 1 .362-.361zm2.873 0h.829a.364.364 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .362.361v.828a.363.363 0 0 1-.362.362h-.828a.362.362 0 0 1-.363-.362v-.828a.364.364 0 0 1 .363-.361zm2.871 0h.829a.362.362 0 0 1 .363.361v.828a.367.367 0 0 1-.107.257.366.366 0 0 1-.256.105h-.829a.364.364 0 0 1-.361-.362v-.828a.364.364 0 0 1 .361-.361zm-8.511 3.131h.829a.364.364 0 0 1 .361.362v.83a.364.364 0 0 1-.361.36h-.829a.361.361 0 0 1-.361-.36v-.829a.367.367 0 0 1 .105-.257.362.362 0 0 1 .256-.106zm2.872 0h.828a.363.363 0 0 1 .361.362v.83a.36.36 0 0 1-.361.36h-.828a.365.365 0 0 1-.362-.361v-.828a.367.367 0 0 1 .105-.257.366.366 0 0 1 .257-.106zm2.871 0h.829a.362.362 0 0 1 .363.362v.83a.366.366 0 0 1-.363.36h-.829a.364.364 0 0 1-.361-.36v-.829a.362.362 0 0 1 .361-.363zm-2.975-6.495h.829a.364.364 0 0 1 .361.361v.829a.36.36 0 0 1-.361.361h-.829a.364.364 0 0 1-.361-.361V63.4a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .362.361v.829a.365.365 0 0 1-.362.361h-.828a.362.362 0 0 1-.363-.361V63.4a.364.364 0 0 1 .363-.361z"
          fill="#EDEDED"
        />
        <path
          d="M117.748 49.274c-3.165.75-6.511-1.934-6.511-1.934s1.786-3.898 4.951-4.645c3.165-.75 6.51 1.932 6.51 1.932s-1.786 3.898-4.95 4.647z"
          fill="url(#5wwssswrhb)"
        />
        <path
          d="M21.572 50.685c-3.165.75-6.512-1.934-6.512-1.934s1.786-3.898 4.952-4.645c3.164-.75 6.51 1.932 6.51 1.932s-1.786 3.897-4.95 4.647z"
          fill="url(#ejf86g1m1c)"
        />
        <path
          d="M61.672 15.796c3.965-.801 6.348-5.576 6.348-5.576s-4.048-3.473-8.013-2.668c-3.965.802-6.348 5.574-6.348 5.574s4.048 3.472 8.013 2.67z"
          fill="url(#byfb6mf7ad)"
        />
        <path
          d="M94.237 82.156c5.023-1.154 7.897-7.315 7.897-7.315s-5.272-4.286-10.294-3.128c-5.023 1.154-7.896 7.31-7.896 7.31s5.271 4.287 10.293 3.133z"
          fill="url(#doj0t2tb2e)"
        />
        <path
          d="M125.239 56.13c-1.482 0-2.684 1.149-2.684 2.567 0 1.418 1.202 2.567 2.684 2.567 1.482 0 2.684-1.15 2.684-2.567 0-1.418-1.202-2.568-2.684-2.568zM47.057 76.974a2.337 2.337 0 1 0 0 4.673 2.337 2.337 0 0 0 0-4.673zM37.43 35.166a1.284 1.284 0 1 1 0-2.567 1.284 1.284 0 0 1 0 2.568zM122.55 27.005c-1.191 0-2.157-1.006-2.157-2.247 0-1.24.966-2.247 2.157-2.247 1.192 0 2.157 1.006 2.157 2.247 0 1.241-.965 2.247-2.157 2.247zM22.522 64.392a1.707 1.707 0 1 1 0-3.415 1.707 1.707 0 0 1 0 3.415z"
          fill="#FFAECD"
        />
        <path
          d="M62.88 78.88c-1.149 0-2.08-.895-2.08-2s.931-2 2.08-2 2.08.895 2.08 2-.931 2-2.08 2zM36.13 50.362a1.368 1.368 0 1 1 0-2.735 1.368 1.368 0 0 1 0 2.735zM75.28 84c-.663 0-1.2-.573-1.2-1.28 0-.707.537-1.28 1.2-1.28.663 0 1.2.573 1.2 1.28 0 .707-.537 1.28-1.2 1.28zM83.994 12.263a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334zM31.58 57.225a1.14 1.14 0 1 1-2.202.59 1.14 1.14 0 0 1 2.203-.59zM39.87 9.993a1.517 1.517 0 1 1 0-3.034 1.517 1.517 0 0 1 0 3.034zM115.417 35.257c-.644 0-1.167-.418-1.167-.933 0-.516.523-.934 1.167-.934.645 0 1.167.418 1.167.934 0 .515-.522.933-1.167.933zM97.578 17.002a2.373 2.373 0 1 1-4.585 1.229 2.373 2.373 0 0 1 4.585-1.229zM127.804 32.402h.031c.18 2.561 2.085 2.6 2.085 2.6s-2.1.041-2.1 3.001c0-2.96-2.101-3-2.101-3s1.904-.04 2.085-2.601zM26.884 21.526h.053c.311 4.483 3.592 4.552 3.592 4.552s-3.618.072-3.618 5.251c0-5.18-3.617-5.251-3.617-5.251s3.279-.07 3.59-4.552z"
          fill="#E1E4E5"
        />
      </g>
      <defs>
        <linearGradient
          id="5wwssswrhb"
          x1="114.71"
          y1="53.558"
          x2="118.137"
          y2="33.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="ejf86g1m1c"
          x1="18.534"
          y1="54.968"
          x2="21.96"
          y2="35.325"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="byfb6mf7ad"
          x1="58.011"
          y1="21.063"
          x2="62.218"
          y2="-3.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="doj0t2tb2e"
          x1="89.456"
          y1="88.928"
          x2="94.873"
          y2="57.813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <clipPath id="6n2uf8irga">
          <path fill="#fff" d="M0 0h144v96H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const VerifyLogo = () => {
  return (
    <svg
      width="144"
      height="96"
      viewBox="0 0 144 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#6n2uf8irga)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.987 50.889V37.444c0-4.522 2.406-8.703 6.313-10.979l12.704-7.394a12.707 12.707 0 0 1 12.78 0l12.705 7.394a12.704 12.704 0 0 1 6.316 10.98v13.444c0 4.522-2.406 8.703-6.313 10.979l-12.704 7.394a12.708 12.708 0 0 1-12.78 0l-12.705-7.394a12.703 12.703 0 0 1-6.316-10.98z"
          fill="#D71A63"
        />
        <path
          d="M75.396 44.167V31.462m-.003 22.586a.702.702 0 0 0-.703.706.706.706 0 0 0 1.412 0 .706.706 0 0 0-.709-.706z"
          stroke="#fff"
          stroke-width="6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.937 66.216h.828a.362.362 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.362.362 0 0 1-.361-.361v-.828a.36.36 0 0 1 .361-.362zm2.872 0h.828a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.828a.363.363 0 0 1-.362-.361v-.828a.362.362 0 0 1 .361-.362zm2.873 0h.828a.363.363 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.362.362 0 0 1-.361-.361v-.828a.36.36 0 0 1 .36-.362zm2.871 0h.829a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.829a.363.363 0 0 1-.363-.361v-.828a.366.366 0 0 1 .363-.362zm2.872 0h.828a.363.363 0 0 1 .364.362v.828a.362.362 0 0 1-.364.361h-.828a.362.362 0 0 1-.361-.361v-.828a.363.363 0 0 1 .361-.362zm-8.511 3.131h.828a.363.363 0 0 1 .361.362v.83a.363.363 0 0 1-.36.361h-.83a.362.362 0 0 1-.36-.361v-.829a.362.362 0 0 1 .36-.363zm2.871 0h.829a.363.363 0 0 1 .361.362v.83a.364.364 0 0 1-.361.361h-.829a.363.363 0 0 1-.361-.361v-.829a.362.362 0 0 1 .361-.363zm2.872 0h.828a.363.363 0 0 1 .363.362v.83a.363.363 0 0 1-.363.361h-.828a.363.363 0 0 1-.361-.361v-.829a.363.363 0 0 1 .361-.363zm-2.975-6.495h.828a.363.363 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .36-.36zm2.871 0h.829a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.829a.363.363 0 0 1-.363-.36v-.83a.365.365 0 0 1 .363-.36zm62.172-43.498h.828a.363.363 0 0 1 .362.361v.828a.36.36 0 0 1-.362.362h-.828a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.828a.365.365 0 0 1-.362-.362v-.828a.365.365 0 0 1 .362-.361zm2.873 0h.828a.365.365 0 0 1 .362.361v.828a.36.36 0 0 1-.362.362h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.871 0h.829a.364.364 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.362.362 0 0 1-.363-.362v-.828a.365.365 0 0 1 .363-.361zm2.872 0h.828a.365.365 0 0 1 .364.361v.828a.366.366 0 0 1-.225.335.362.362 0 0 1-.139.027h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm-8.511 3.13h.828a.365.365 0 0 1 .362.361v.831a.365.365 0 0 1-.362.362h-.828a.366.366 0 0 1-.362-.362v-.828a.368.368 0 0 1 .106-.257.354.354 0 0 1 .256-.106zm2.871 0h.829a.364.364 0 0 1 .361.362v.83a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.367.367 0 0 1 .105-.257.369.369 0 0 1 .256-.106zm2.872 0h.828a.366.366 0 0 1 .364.361v.831a.366.366 0 0 1-.364.362h-.828a.362.362 0 0 1-.361-.362v-.828a.364.364 0 0 1 .361-.363zm-2.975-6.494h.828a.365.365 0 0 1 .362.361v.829a.36.36 0 0 1-.362.36h-.828a.362.362 0 0 1-.361-.36v-.829a.36.36 0 0 1 .361-.361zm2.871 0h.829a.364.364 0 0 1 .361.361v.829a.36.36 0 0 1-.361.36h-.829a.363.363 0 0 1-.363-.36v-.829a.366.366 0 0 1 .363-.361zm-76.636 4.155h.829a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.829a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .361-.36zm2.872 0h.828a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.828a.363.363 0 0 1-.362-.36v-.83a.363.363 0 0 1 .362-.36zm2.873 0h.828a.362.362 0 0 1 .362.36v.83a.362.362 0 0 1-.362.36h-.828a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .361-.36zm2.872 0h.828a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.828a.363.363 0 0 1-.364-.36v-.83a.365.365 0 0 1 .364-.36zm2.871 0h.829a.363.363 0 0 1 .363.36v.83a.363.363 0 0 1-.363.36h-.829a.363.363 0 0 1-.361-.36v-.83a.363.363 0 0 1 .361-.36zm-8.51 3.13h.827a.363.363 0 0 1 .362.362v.83a.363.363 0 0 1-.362.362h-.828a.362.362 0 0 1-.361-.362v-.828a.359.359 0 0 1 .361-.363zm2.87 0h.829a.363.363 0 0 1 .361.362v.83a.363.363 0 0 1-.361.362h-.828a.362.362 0 0 1-.362-.362v-.828a.362.362 0 0 1 .362-.363zm2.872 0h.829a.363.363 0 0 1 .363.362v.83a.364.364 0 0 1-.363.362h-.829a.363.363 0 0 1-.361-.362v-.828a.363.363 0 0 1 .361-.363zm-2.975-6.494h.828a.363.363 0 0 1 .362.361v.828a.362.362 0 0 1-.362.362h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.363.363 0 0 1 .361.361v.828a.361.361 0 0 1-.361.362h-.828a.363.363 0 0 1-.364-.362v-.828a.366.366 0 0 1 .364-.361zm60.319 49.623h.829a.359.359 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.365.365 0 0 1 .362.361v.828a.365.365 0 0 1-.362.362h-.828a.365.365 0 0 1-.362-.362v-.828a.365.365 0 0 1 .362-.361zm2.873 0h.829a.364.364 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .362.361v.828a.363.363 0 0 1-.362.362h-.828a.362.362 0 0 1-.363-.362v-.828a.364.364 0 0 1 .363-.361zm2.871 0h.829a.362.362 0 0 1 .363.361v.828a.367.367 0 0 1-.107.257.366.366 0 0 1-.256.105h-.829a.364.364 0 0 1-.361-.362v-.828a.364.364 0 0 1 .361-.361zm-8.511 3.131h.829a.364.364 0 0 1 .361.362v.83a.364.364 0 0 1-.361.36h-.829a.361.361 0 0 1-.361-.36v-.829a.367.367 0 0 1 .105-.257.362.362 0 0 1 .256-.106zm2.872 0h.828a.363.363 0 0 1 .361.362v.83a.36.36 0 0 1-.361.36h-.828a.365.365 0 0 1-.362-.361v-.828a.367.367 0 0 1 .105-.257.366.366 0 0 1 .257-.106zm2.871 0h.829a.362.362 0 0 1 .363.362v.83a.366.366 0 0 1-.363.36h-.829a.364.364 0 0 1-.361-.36v-.829a.362.362 0 0 1 .361-.363zm-2.975-6.495h.829a.364.364 0 0 1 .361.361v.829a.36.36 0 0 1-.361.361h-.829a.364.364 0 0 1-.361-.361V63.4a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .362.361v.829a.365.365 0 0 1-.362.361h-.828a.362.362 0 0 1-.363-.361V63.4a.364.364 0 0 1 .363-.361z"
          fill="#EDEDED"
        />
        <path
          d="M117.748 49.274c-3.165.75-6.511-1.934-6.511-1.934s1.786-3.898 4.951-4.645c3.165-.75 6.51 1.932 6.51 1.932s-1.786 3.898-4.95 4.647z"
          fill="url(#5wwssswrhb)"
        />
        <path
          d="M21.572 50.685c-3.165.75-6.512-1.934-6.512-1.934s1.786-3.898 4.952-4.645c3.164-.75 6.51 1.932 6.51 1.932s-1.786 3.897-4.95 4.647z"
          fill="url(#ejf86g1m1c)"
        />
        <path
          d="M61.672 15.796c3.965-.801 6.348-5.576 6.348-5.576s-4.048-3.473-8.013-2.668c-3.965.802-6.348 5.574-6.348 5.574s4.048 3.472 8.013 2.67z"
          fill="url(#byfb6mf7ad)"
        />
        <path
          d="M94.237 82.156c5.023-1.154 7.897-7.315 7.897-7.315s-5.272-4.286-10.294-3.128c-5.023 1.154-7.896 7.31-7.896 7.31s5.271 4.287 10.293 3.133z"
          fill="url(#doj0t2tb2e)"
        />
        <path
          d="M125.239 56.13c-1.482 0-2.684 1.149-2.684 2.567 0 1.418 1.202 2.567 2.684 2.567 1.482 0 2.684-1.15 2.684-2.567 0-1.418-1.202-2.568-2.684-2.568zM47.057 76.974a2.337 2.337 0 1 0 0 4.673 2.337 2.337 0 0 0 0-4.673zM37.43 35.166a1.284 1.284 0 1 1 0-2.567 1.284 1.284 0 0 1 0 2.568zM122.55 27.005c-1.191 0-2.157-1.006-2.157-2.247 0-1.24.966-2.247 2.157-2.247 1.192 0 2.157 1.006 2.157 2.247 0 1.241-.965 2.247-2.157 2.247zM22.522 64.392a1.707 1.707 0 1 1 0-3.415 1.707 1.707 0 0 1 0 3.415z"
          fill="#FFAECD"
        />
        <path
          d="M62.88 78.88c-1.149 0-2.08-.895-2.08-2s.931-2 2.08-2 2.08.895 2.08 2-.931 2-2.08 2zM36.13 50.362a1.368 1.368 0 1 1 0-2.735 1.368 1.368 0 0 1 0 2.735zM75.28 84c-.663 0-1.2-.573-1.2-1.28 0-.707.537-1.28 1.2-1.28.663 0 1.2.573 1.2 1.28 0 .707-.537 1.28-1.2 1.28zM83.994 12.263a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334zM31.58 57.225a1.14 1.14 0 1 1-2.202.59 1.14 1.14 0 0 1 2.203-.59zM39.87 9.993a1.517 1.517 0 1 1 0-3.034 1.517 1.517 0 0 1 0 3.034zM115.417 35.257c-.644 0-1.167-.418-1.167-.933 0-.516.523-.934 1.167-.934.645 0 1.167.418 1.167.934 0 .515-.522.933-1.167.933zM97.578 17.002a2.373 2.373 0 1 1-4.585 1.229 2.373 2.373 0 0 1 4.585-1.229zM127.804 32.402h.031c.18 2.561 2.085 2.6 2.085 2.6s-2.1.041-2.1 3.001c0-2.96-2.101-3-2.101-3s1.904-.04 2.085-2.601zM26.884 21.526h.053c.311 4.483 3.592 4.552 3.592 4.552s-3.618.072-3.618 5.251c0-5.18-3.617-5.251-3.617-5.251s3.279-.07 3.59-4.552z"
          fill="#E1E4E5"
        />
      </g>
      <defs>
        <linearGradient
          id="5wwssswrhb"
          x1="114.71"
          y1="53.558"
          x2="118.137"
          y2="33.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="ejf86g1m1c"
          x1="18.534"
          y1="54.968"
          x2="21.96"
          y2="35.325"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="byfb6mf7ad"
          x1="58.011"
          y1="21.063"
          x2="62.218"
          y2="-3.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="doj0t2tb2e"
          x1="89.456"
          y1="88.928"
          x2="94.873"
          y2="57.813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <clipPath id="6n2uf8irga">
          <path fill="#fff" d="M0 0h144v96H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const NotAllowedLogo = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36z"
        fill="#D71A63"
      />
      <path
        d="M36 16c10.968 0 20 9.032 20 20 0 11.048-9.032 20-20 20-11.048 0-20-8.952-20-20 0-10.968 8.952-20 20-20zm0 36.129c8.871 0 16.129-7.177 16.129-16.129 0-8.871-7.258-16.129-16.129-16.129-8.952 0-16.129 7.258-16.129 16.129A16.073 16.073 0 0 0 36 52.129zm0-27.258c1.855 0 3.387 1.532 3.387 3.387 0 1.936-1.532 3.387-3.387 3.387-1.935 0-3.387-1.451-3.387-3.387 0-1.855 1.452-3.387 3.387-3.387zm4.516 20.484c0 .564-.484.968-.968.968h-7.096c-.565 0-.968-.404-.968-.968v-1.936c0-.483.403-.967.968-.967h.967V37.29h-.967c-.565 0-.968-.403-.968-.967v-1.936c0-.484.403-.968.968-.968h5.16c.485 0 .969.484.969.968v8.065h.967c.484 0 .968.483.968.967v1.936z"
        fill="#fff"
      />
    </svg>
  );
};
export const SuccessLogo = () => {
  return (
    <svg
      width="144"
      height="96"
      viewBox="0 0 144 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#6oc2pqupoa)">
        <path
          d="M25.024 56.953c-.672 12.375 23.523 37.54 53.346 28.225 13.87-4.332 12.695-11.522 23.241-21 6.287-5.647 15.319-9.919 17.831-18.129 2.171-7.086.84-14.703-2.923-19.657-8.461-11.143-25.544-18.772-42.376-1.217-16.831 17.555-47.383-.14-49.12 31.778z"
          fill="url(#ojzvghaycb)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M74.519 81.135c17.236 0 31.209-13.931 31.209-31.116 0-17.185-13.973-31.117-31.21-31.117-17.236 0-31.208 13.932-31.208 31.117 0 17.185 13.972 31.116 31.209 31.116z"
          fill="#D71A63"
        />
        <path
          d="M31.606 57.357a1.672 1.672 0 1 1 0 3.344 1.672 1.672 0 0 1 0-3.344zM115.838 39.341a2.341 2.341 0 1 1-2.341-4.055 2.341 2.341 0 0 1 2.341 4.055z"
          fill="#242424"
        />
        <path
          d="M34.486 36.922a1.765 1.765 0 1 0 0 3.53 1.765 1.765 0 0 0 0-3.53zM78.762 15.135a2.274 2.274 0 1 1-2.274-3.939 2.274 2.274 0 0 1 2.274 3.939z"
          fill="#E1E4E5"
        />
        <path
          d="M49.161 20.834a2.322 2.322 0 1 0 0-4.644 2.322 2.322 0 0 0 0 4.644zM99.206 80.696a2.428 2.428 0 1 0-2.429 4.206 2.428 2.428 0 0 0 2.429-4.206z"
          fill="#242424"
        />
        <path
          d="M36.715 78.348a1.765 1.765 0 1 1 0-3.53 1.765 1.765 0 0 1 0 3.53zM125.575 49.04a1.323 1.323 0 1 1-1.325 2.292 1.323 1.323 0 0 1 1.325-2.291zM117.668 59.916a3.114 3.114 0 1 0-3.113 5.393 3.114 3.114 0 0 0 3.113-5.393zM108.569 21.07l-4.161 4.16a.389.389 0 0 0 .549.55l4.161-4.162a.389.389 0 0 0-.549-.548zM108.161 24.049l-1.2 1.2a.389.389 0 0 0 .549.549l1.2-1.2a.388.388 0 0 0-.549-.549zM19.121 48.06l4.161-4.16a.388.388 0 0 0-.548-.55l-4.161 4.162a.388.388 0 0 0 .548.548zM19.528 45.081l1.2-1.2a.388.388 0 0 0-.549-.548l-1.2 1.2a.388.388 0 0 0 .549.548zM51.005 80.96l-4.161 4.16a.388.388 0 0 0 .548.549l4.161-4.161a.388.388 0 1 0-.548-.549zM50.597 83.938l-1.2 1.2a.388.388 0 0 0 .549.549l1.2-1.2a.388.388 0 0 0-.549-.549zM58.994 15.619l4.16-4.161a.388.388 0 1 0-.548-.549l-4.16 4.161a.388.388 0 1 0 .548.549zM59.401 12.64l1.2-1.2a.388.388 0 1 0-.549-.55l-1.2 1.2a.388.388 0 1 0 .55.55z"
          fill="#E1E4E5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M86.24 8.612h.467c.113 0 .204.091.204.203v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.203-.204v-.467a.201.201 0 0 1 .06-.144.203.203 0 0 1 .143-.06zm1.619 0h.467c.112 0 .204.091.204.203v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467c0-.112.092-.203.204-.203zm1.62 0h.466c.112 0 .204.091.204.203v.467a.204.204 0 0 1-.204.204h-.466a.205.205 0 0 1-.204-.204v-.467a.205.205 0 0 1 .126-.188.204.204 0 0 1 .078-.015zm1.618 0h.467c.112 0 .204.091.204.203v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467c0-.112.092-.203.204-.203zm1.62 0h.466c.113 0 .205.091.205.203v.467a.204.204 0 0 1-.205.204h-.467a.205.205 0 0 1-.204-.204v-.467c0-.112.092-.203.204-.203zm-4.799 1.765h.467c.112 0 .204.091.204.204v.467a.204.204 0 0 1-.204.204h-.467a.204.204 0 0 1-.204-.204v-.467a.204.204 0 0 1 .204-.204zm1.62 0h.466c.112 0 .204.091.204.204v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467a.202.202 0 0 1 .126-.189.204.204 0 0 1 .078-.015zm1.618 0h.466c.114 0 .205.091.205.204v.467a.205.205 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467c0-.112.092-.204.204-.204zm-1.677-3.662h.466a.205.205 0 0 1 .204.204v.467a.204.204 0 0 1-.204.204h-.466a.205.205 0 0 1-.204-.204V6.92a.205.205 0 0 1 .126-.188.204.204 0 0 1 .078-.016zm1.618 0h.467a.205.205 0 0 1 .204.204v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204V6.92c0-.112.092-.204.204-.204zm20.106 66.36h-.466a.203.203 0 0 1-.204-.204v-.467c0-.113.092-.204.204-.204h.466c.112 0 .204.092.204.204v.467a.198.198 0 0 1-.125.189.208.208 0 0 1-.079.015zm-1.618 0h-.467a.204.204 0 0 1-.204-.204v-.467c0-.113.092-.204.204-.204h.467c.112 0 .204.092.204.204v.467a.205.205 0 0 1-.204.204zm-1.62 0h-.467a.204.204 0 0 1-.203-.204v-.467c0-.113.091-.204.203-.204h.467c.112 0 .204.092.204.204v.467a.209.209 0 0 1-.015.078.22.22 0 0 1-.045.066.2.2 0 0 1-.144.06zm-1.619 0h-.466a.204.204 0 0 1-.204-.204v-.467c0-.113.092-.204.204-.204h.466c.113 0 .205.092.205.204v.467a.206.206 0 0 1-.205.204zm-1.618 0h-.467a.206.206 0 0 1-.205-.204v-.467c0-.113.092-.204.205-.204h.467c.112 0 .204.092.204.204v.467a.205.205 0 0 1-.204.204zm4.798-1.765h-.467a.205.205 0 0 1-.204-.204v-.468c0-.112.092-.204.204-.204h.467c.112 0 .203.092.203.204v.467a.21.21 0 0 1-.059.145.202.202 0 0 1-.144.06zm-1.619 0h-.467a.204.204 0 0 1-.204-.204v-.468c0-.112.092-.204.204-.204h.467c.112 0 .204.092.204.204v.467a.193.193 0 0 1-.016.078.2.2 0 0 1-.11.111.201.201 0 0 1-.078.016zm-1.619 0h-.467a.204.204 0 0 1-.204-.204v-.468c0-.112.091-.204.204-.204h.467c.112 0 .204.092.204.204v.467a.206.206 0 0 1-.204.205zm1.677 3.66h-.467a.204.204 0 0 1-.203-.203V74.3c0-.113.091-.204.203-.204h.467c.112 0 .204.092.204.204v.467a.209.209 0 0 1-.015.078.218.218 0 0 1-.045.066.2.2 0 0 1-.144.06zm-1.619 0h-.466a.205.205 0 0 1-.204-.203V74.3c0-.113.092-.204.204-.204h.466c.113 0 .205.092.205.204v.467a.204.204 0 0 1-.205.204zM37.011 27.933h.467c.113 0 .204.091.204.203v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.203-.204v-.467a.205.205 0 0 1 .125-.188.203.203 0 0 1 .078-.015zm1.62 0h.466c.112 0 .204.091.204.203v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467c0-.112.092-.203.204-.203zm1.619 0h.467c.112 0 .203.091.203.203v.467a.204.204 0 0 1-.203.204h-.467a.204.204 0 0 1-.204-.204v-.467a.205.205 0 0 1 .126-.188.202.202 0 0 1 .078-.015zm1.618 0h.467c.112 0 .204.091.204.203v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467a.206.206 0 0 1 .204-.203zm1.62 0h.466a.204.204 0 0 1 .205.203v.467a.204.204 0 0 1-.205.204h-.467a.205.205 0 0 1-.204-.204v-.467c0-.112.092-.203.204-.203zm-4.799 1.765h.467c.112 0 .204.091.204.203v.468a.205.205 0 0 1-.204.204h-.467a.204.204 0 0 1-.203-.204v-.467a.204.204 0 0 1 .203-.204zm1.62 0h.466c.112 0 .204.091.204.203v.468a.205.205 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467a.202.202 0 0 1 .126-.189.204.204 0 0 1 .078-.015zm1.618 0h.467a.205.205 0 0 1 .204.203v.468a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467c0-.113.092-.204.204-.204zm-1.677-3.662h.467c.112 0 .203.092.203.204v.467a.204.204 0 0 1-.203.204h-.467a.204.204 0 0 1-.204-.204v-.467a.202.202 0 0 1 .204-.204zm1.618 0h.467c.112 0 .204.092.204.204v.467a.204.204 0 0 1-.204.204h-.467a.205.205 0 0 1-.204-.204v-.467a.206.206 0 0 1 .204-.204z"
          fill="#E1E4E5"
        />
        <path
          d="m81.354 46.045-9.571 9.557-4.35-4.344"
          stroke="#fff"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="ojzvghaycb"
          x1="53.942"
          y1="131.134"
          x2="99.201"
          y2="-73.056"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <clipPath id="6oc2pqupoa">
          <path fill="#fff" d="M0 0h144v96H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
